import { CheckUpPropertyMeasurement, IFetchCheckUpPropertiesParams } from '~/interfaces'
import { axios, AxiosResponse } from '~/modules'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchCheckUpProperties = async (
  params: IFetchCheckUpPropertiesParams
): Promise<CheckUpPropertyMeasurement[]> => {
  const { pathParams, queryParams } = params
  const response = await axios.get(
    `${hstoryAPI}/patients/${pathParams.patientId}/metabolic-syndrome-prediction-property-measurements`,
    {
      params: { sensitivity: queryParams.sensitivity, simulation: queryParams.simulation }
    }
  )
  const { data }: AxiosResponse<CheckUpPropertyMeasurement[]> = response
  return data
}
